/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2025-04-07 10:04:15
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-04-07 10:16:43
 */
import fileService from '@/utils/request.file'

// 批量获取附件地址
export const getFileUrls = (params: any) =>
  fileService.request({
    method: 'post',
    url: 'common/file/getFileUrls',
    data: params
  })
